// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1KlRT","title":"ClientReferral_title__2j5RE","itemText":"ClientReferral_itemText__36y5Q"};